import { Autocomplete, Checkbox, ListItemText, TextField } from "@mui/material";
import React from "react";

const SearchableDropdown = ({
  width,
  options = [],
  selectedOptions = [],
  onChange,
  label = "Select",
  getOptionLabel = (option) => option.label,
  getOptionKey = (option) => option.id || option.label,
}) => {
  return (
    <Autocomplete
      multiple
      options={options}
      value={selectedOptions}
      onChange={(event, newValue) => onChange(newValue)}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={(option, value) =>
        getOptionKey(option) === getOptionKey(value)
      }
      renderOption={(props, option, { selected }) => (
        <li {...props} key={getOptionKey(option)}>
          <Checkbox style={{ marginRight: 8 }} checked={selected} />

          <ListItemText primary={getOptionLabel(option)} />
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder="Search..."
        />
      )}
      sx={{ width: width }}
    />
  );
};

export default SearchableDropdown;
